import { ENTITY_ICONS, studyEntityIcon } from '@/lib/icons/entityIcons'

export type RecentKindIconKind = 'thread' | 'room' | 'study'

interface RecentKindIconProps {
  kind: RecentKindIconKind
  goalId?: string | null
}

/**
 * Small leading icon that tells the Recent rail's row kinds apart. Decorative:
 * the row carries the kind name as sr-only text. Icons match the nav entries
 * (Studies `FileBarChart`, Conversations `MessagesSquare`; threads a single
 * bubble).
 */
export function RecentKindIcon(props: RecentKindIconProps) {
  const { kind } = props

  const Icon = kind === 'study' ? studyEntityIcon(props.goalId) : ENTITY_ICONS[kind]

  return (
    <Icon
      aria-hidden
      data-testid={`sidebar-kind-icon-${kind}`}
      className="h-3.5 w-3.5 shrink-0 text-sidebar-foreground/55"
      strokeWidth={1.75}
    />
  )
}
